export const LANGUAGE_SPANISH = 'SPA'
export const LANGUAGE_ENGLISH = 'ENG'
export const LANGUAGE_ALL = 'ALL'
